import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

const MayBeShowNavBar = ({ children }) => {

    const location = useLocation();

    const [showNavBar, setShowNavBar] = useState(false)

    const isAdmin = (sessionStorage.getItem("role") === "admin");
    const isUser = (sessionStorage.getItem("role") === "user");
    const isLogged = (isAdmin || isUser);

    useEffect(() => {
        if (location.pathname === "/login" || location.pathname === "/" || location.pathname === "/documentnotfound") {
            setShowNavBar(false)
        } else if (isLogged && (location.pathname === "/users" ||
            location.pathname === "/newuser" ||
            location.pathname.includes("/modificationuser") ||
            location.pathname === "/changepassword" ||
            location.pathname === "/newredirection" ||
            location.pathname.includes("/modificationredirection/") ||
            location.pathname === "/redirections")) {
            setShowNavBar(true)
        }
    }, [isLogged, location])

    return (
        <div>{showNavBar && children}</div>
    )
}

export default MayBeShowNavBar;